import { useMemo, useState } from 'react';

import { Offer } from '../../../models/offers.model';

export type SortOption =
  | 'lastModified-desc'
  | 'lastModified-asc'
  | 'createdAt-desc'
  | 'createdAt-asc'
  | 'price-asc'
  | 'price-desc';

interface UseOfferSortReturn {
  sortedOffers: Offer[];
  sortBy: SortOption;
  setSortBy: (value: SortOption) => void;
}

export function useOfferSort(offers: Offer[], defaultSort: SortOption = 'lastModified-desc'): UseOfferSortReturn {
  const [sortBy, setSortBy] = useState<SortOption>(defaultSort);

  const sortedOffers = useMemo(() => {
    const sorted = [...offers];
    const [field, order] = sortBy.split('-');

    sorted.sort((a, b) => {
      let aVal, bVal;

      if (field === 'price') {
        aVal = a.price || 0;
        bVal = b.price || 0;
      } else if (field === 'lastModified') {
        aVal = a.lastModified instanceof Date ? a.lastModified.getTime() : 0;
        bVal = b.lastModified instanceof Date ? b.lastModified.getTime() : 0;
      } else if (field === 'createdAt') {
        aVal = a.createdAt instanceof Date ? a.createdAt.getTime() : 0;
        bVal = b.createdAt instanceof Date ? b.createdAt.getTime() : 0;
      }

      return order === 'asc' ? aVal - bVal : bVal - aVal;
    });

    return sorted;
  }, [offers, sortBy]);

  return { sortedOffers, sortBy, setSortBy };
}
